import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=b37b282e&scoped=true&"
import script from "./NavigationMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=b37b282e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37b282e",
  null
  
)

export default component.exports